import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../common/store/types';
import { ContractTerminationReasonModel } from './types';
import { contractTerminationReasonActions } from './contract-termination-reason.actions';

export interface IContractTerminationReasonState
  extends IState<ContractTerminationReasonModel> {
  getById: GenericState<ContractTerminationReasonModel>;
  createInstance: GenericState<ContractTerminationReasonModel>;
  add: GenericState<ContractTerminationReasonModel>;
  update: GenericState<ContractTerminationReasonModel>;
}

export const contractTerminationReasonInitialState: IContractTerminationReasonState =
  {
    getById: new GenericState<ContractTerminationReasonModel>(),
    createInstance: new GenericState<ContractTerminationReasonModel>(),
    add: new GenericState<ContractTerminationReasonModel>(),
    update: new GenericState<ContractTerminationReasonModel>(),
  };

const contractTerminationReasonReducers = [
  ...onApiCall<ContractTerminationReasonModel>(
    contractTerminationReasonActions.getById,
    'getById',
  ),
  ...onApiCall<ContractTerminationReasonModel>(
    contractTerminationReasonActions.createInstance,
    'createInstance',
  ),
  ...onApiCall<ContractTerminationReasonModel>(
    contractTerminationReasonActions.add,
    'add',
  ),
  ...onApiCall<ContractTerminationReasonModel>(
    contractTerminationReasonActions.update,
    'update',
  ),
];

export const contractTerminationReasonReducer = createReducer(
  contractTerminationReasonInitialState,
  ...contractTerminationReasonReducers,
) as ActionReducer<IContractTerminationReasonState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return contractTerminationReasonReducer(state, action);
}
